module.exports = __webpack_public_path__ + "img/ac4.93c811e2.png";